<input id="dateTime" type="datetime-local" class="form-control form-control-sm w-100" [(ngModel)]="dateTime" (ngModelChange)="onDateTimeChange()" (blur)="onBlur()" style="min-width: 0;" />

